import React from 'react';

class HelperGenerics {

	static getBlankOrValue(value) {
		if (value == null) {
			return '';
		}
		return value;
	}
	static getNullOrValue(value) {
		if (value === '') {
			return null;
		}
		return value;
	}

	static isNotNullAndNotEmpty(value) {
		return value != null && value.length > 0;
	}
	static isNotNullAndNotEmptyNumInput(value) {
		return value != null && value !== '';
	}

	static initAmountInclExclTax(valueInclTax, valueExclTax) {
		if (valueInclTax != null || valueExclTax != null) {
			var result = {};
			if (valueExclTax) {
				result.amountExclTax = parseFloat(valueExclTax);
			}
			if (valueInclTax) {
				result.amountInclTax = parseFloat(valueInclTax);
			}
			return result;
		}
		return null;
	}

	static updateFieldIfNotNull(objectSource, fieldnameSource, objectDest, fieldnameDest) {
		if (objectSource != null && objectSource[fieldnameSource] != null && objectDest != null) {
			objectDest[fieldnameDest] = objectSource[fieldnameSource];
		}
	}
	static updateFieldIfNotNullAndNotEmpty(objectSource, fieldnameSource, objectDest, fieldnameDest) {
		if (objectSource != null && objectSource[fieldnameSource] != null && objectSource[fieldnameSource].length > 0 && objectDest != null) {
			objectDest[fieldnameDest] = objectSource[fieldnameSource];
		}
	}
	static updateFieldIfNotNullAndNotEmptyNumInput(objectSource, fieldnameSource, objectDest, fieldnameDest) {
		if (objectSource != null && objectSource[fieldnameSource] != null && objectSource[fieldnameSource] !== '' && objectDest != null) {
			objectDest[fieldnameDest] = objectSource[fieldnameSource] * 1;
		}
	}
	static updateFieldIfNotNullAndNotEmptyFloatInput(objectSource, fieldnameSource, objectDest, fieldnameDest) {
		if (objectSource != null && objectSource[fieldnameSource] != null && objectSource[fieldnameSource] !== '' && objectDest != null) {
			objectDest[fieldnameDest] = objectSource[fieldnameSource] * 1.0;
		}
	}

	static maxOrNullBetweenBounds(a, b) {
		if (a === null) {
			return b;
		}
		if (b === null) {
			return a;
		}
		return Math.max(a, b);
	}
	static minOrNullBetweenBounds(a, b) {
		if (a === null) {
			return b;
		}
		if (b === null) {
			return a;
		}
		return Math.min(a, b);
	}

	static maxOrNullIfOneNull(a, b) {
		if (a === null || b === null) {
			return null;
		}
		return Math.max(a, b);
	}
	static minOrNullIfOneNull(a, b) {
		if (a === null || b === null) {
			return null;
		}
		return Math.min(a, b);
	}

	static rebuildWordAndSpace(value) {
		if (value == null) {
			return null;
		}
		return value.replace(/[^\w\s]+/g, '').replace(/^\s+/g,'').replace(/\s+$/g,'');
	}

	static rebuildAnchor(value) {
		if (value == null) {
			return null;
		}
		return value.replace(/\W+/g, '-').toLowerCase();
	}

	static rebuildWord(value) {
		if (value == null || !value.replace) {
			return null;
		}
		return value.replace(/\W+/g, '');
	}

	static renderLink(url, anchor, text, className) {
		let isShow = true;
		if (anchor == null && url == null) {
			isShow = false;
		}

		const urlObj = HelperGenerics.renderLink01BuildInitialLink(url, anchor);
		if(urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:'){
			isShow = false;
		}
		const parameters = {'rel': 'noopener noreferrer'};
		if(className){
			parameters.className = className;
		}
		if(url){
			parameters.target = '_blank';
		}
		parameters.href = urlObj.toString();

		return (
			<React.Fragment>
				{isShow &&
					React.createElement('a', {...parameters}, text)}
				{!isShow && text}
			</React.Fragment>
		);
	}

	static renderLink01BuildInitialLink(url, anchor){
		const anchorCleaned = HelperGenerics.rebuildAnchor(anchor);
		let initialLink = url == null ? window.location.origin : url;
		if (/javascript:/i.test(initialLink)) {
			initialLink = '';
		}
		const pageUrl = new URL(initialLink);
		let urlStr = `${pageUrl.origin}${pageUrl.pathname}`;
		if(anchorCleaned){
			urlStr = `${urlStr}#${anchorCleaned}`;
		}
		if(pageUrl.search){
			urlStr = `${urlStr}${pageUrl.search}`;
		}
		return new URL(urlStr);
	}

}

export default HelperGenerics;
